<ui-control-field
  class="control"
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  @if (iconName()) {
    <p-iconField iconPosition="left">
      <p-inputIcon [class]="iconName()" />
      <input
        pInputText
        class="control__input"
        [class.control__input]="iconName()"
        [id]="id()"
        [placeholder]="placeholder()"
        [value]="value()"
        [disabled]="disabled()"
        (input)="updateValue($any($event.target).value)"
        (blur)="markAsTouched()" />
    </p-iconField>
  } @else {
    <input
      pInputText
      class="control__input"
      [class.control__input]="iconName()"
      [id]="id()"
      [placeholder]="placeholder()"
      [value]="value()"
      [disabled]="disabled()"
      (input)="updateValue($any($event.target).value)"
      (blur)="markAsTouched()" />
  }
</ui-control-field>
